<div>
  <section class="basicbox clase grupo">
    <header>
      <div class="wrapicon">
        <img src="/assets/img/padreslogoazul.png" alt="" />
      </div>
      <h3 translate>dashboard.padres.titulo</h3>
    </header>

    <div class="claseheader">
      <ng-container *ngFor="let padre of padres">
        <div class="padresbox chat headinguser">
          <div class="boximage">
            <img
              *ngIf="padre.datos.avatar; else defaultavatar"
              src="{{ padre.datos.avatar }}"
              alt="{{ padre.datos.name | titlecase }}"
            />
            <ng-template #defaultavatar
              ><img
                src="assets/img/defaultavatar.jpg"
                alt="{{ padre.datos.name | titlecase }}"
            /></ng-template>
          </div>
          <div class="boxtitles">
            <h4>
              {{ padre.datos.name | titlecase }} {{ padre.datos.last_name | titlecase }}
            </h4>
          </div>

          <div class="button-chat">
            <a routerLink="/dashboard/mensajes/chat/{{ padre.chaturl }}">
              <img src="/assets/img/chatbox-b.svg" />
            </a>
          </div>
        </div>
      </ng-container>
    </div>

    <div></div>
  </section>
</div>
